import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  Grid,
  Typography,
  Container,
  Modal,
  TextField,
  Stack,
  CircularProgress,
} from "@mui/material";
import FacebookIcon from "@mui/icons-material/Facebook";
import XIcon from "@mui/icons-material/X";
import InstagramIcon from "@mui/icons-material/Instagram";
import YouTubeIcon from "@mui/icons-material/YouTube";
import ReplayIcon from "@mui/icons-material/Replay";
import styles from "./FooterModule.module.css";
import footerImg from "../../images/handFooter.webp";
import footerQr from "../../images/clarity_qr-code-line.webp";
import playBtn from "../../images/Googleplay.png";
import storeBtn from "../../images/Appstore (3).png";
import webBtn from "../../images/desihisab.png";
import { NavLink, useLocation } from "react-router-dom";

// API + Captcha
import { loginApi } from "../api.js";
import {
  LoadCanvasTemplateNoReload,
  loadCaptchaEnginge,
  validateCaptcha,
} from "react-simple-captcha";

const FooterModule = () => {
  const location = useLocation();

  // === Login States ===
  const [phone, setPhone] = useState("");
  const [errorColor, setErrorColor] = useState("");
  const [loginSuccess, setLoginSuccess] = useState("");
  const [networkError, setNetworkError] = useState("");
  const [numberArray, setNumberArray] = useState([]);
  const [loginAttempts, setLoginAttempts] = useState(0);
  const [openPopup, setOpenPopup] = useState(false);
  const [captchaError, setCaptchaError] = useState(false);
  const [phoneError, setPhoneError] = useState(false);
  const [loader, setLoader] = useState(false);

  // === Login Logic ===
  const loginFun = async () => {
    if (!navigator.onLine) {
      if (phone.length !== 10 || !/^[6-9]\d{9}$/.test(phone)) {
        setPhoneError(true);
        setNetworkError("");
      } else {
        setPhoneError(false);
        setLoader(false);
        setNetworkError(
          "You are currently offline. Please check your internet connection."
        );
      }
      return;
    }
    setLoader(true);

    const phoneNumberPattern = /^[6-9]\d{9}$/;
    if (phone.length === 10 && phoneNumberPattern.test(phone)) {
      const formdata = new FormData();
      formdata.append("mobile_number", phone);

      try {
        if (loginAttempts < 2) {
          const result = await loginApi(formdata);
          if (result.data.status === "200") {
            setNetworkError("");
            setPhone("");
            setLoginSuccess(result.data.message);
            setPhoneError(false);
            setNumberArray((prevArray) => {
              setLoader(false);
              if (
                prevArray.length > 0 &&
                prevArray[prevArray.length - 1] === phone
              ) {
                setLoginAttempts(loginAttempts + 1);
                return [...prevArray, phone];
              } else {
                setLoginAttempts(1);
                return [phone];
              }
            });
            setErrorColor(result.data.status);
          } else {
            setErrorColor(result.data.status);
            setLoginSuccess(result.data.message);
            setPhone("");
            setLoader(false);
          }
        } else {
          if (numberArray[numberArray.length - 1] === phone) {
            setOpenPopup(true);
            setLoader(false);
            setLoginAttempts(0);
          } else {
            setLoginAttempts(loginAttempts + 1);
            setNumberArray((prevArray) => [...prevArray, phone]);
            const result = await loginApi(formdata);
            if (result.data.status === "200") {
              setPhone("");
              setLoginSuccess(result.data.message);
              setPhoneError(false);
              setLoginAttempts(1);
              setErrorColor(result.data.status);
            } else {
              setErrorColor(result.data.status);
              setLoginSuccess(result.data.message);
              setPhone("");
            }
          }
        }
      } catch (error) {
        setLoginSuccess("");
      }
      setPhoneError(false);
    } else {
      setPhoneError(true);
      setLoader(false);
      setLoginSuccess("");
    }
  };

  const handlePhoneChange = (e) => {
    const numericValue = e.target.value.replace(/[^0-9]/g, "");
    setPhone(numericValue);
    setLoginSuccess("");
  };

  const handlePhoneBlur = () => {
    setTimeout(() => {
      if (phone.length !== 10 || !/^[6-9]\d{9}$/.test(phone)) {
        setPhoneError(true);
        setLoginSuccess("");
        setNetworkError("");
      }
    }, 100);
  };

  const captchaSubmit = () => {
    let userCaptcha = document.getElementById("user_captcha_input").value;

    if (validateCaptcha(userCaptcha) === true) {
      loadCaptchaEnginge(6);
      document.getElementById("user_captcha_input").value = "";
      loginFun();
      setOpenPopup(false);
      setCaptchaError(false);
    } else {
      setCaptchaError(true);
      document.getElementById("user_captcha_input").value = "";
    }
  };

  const handleReloadCaptcha = () => {
    loadCaptchaEnginge(6);
  };

  useEffect(() => {
    if (openPopup) {
      const initializeCaptcha = async () => {
        await new Promise((resolve) => {
          loadCaptchaEnginge(6);
          document.addEventListener("DOMContentLoaded", resolve);
        });
      };
      setTimeout(() => {
        initializeCaptcha();
      }, 0);
    }
  }, [openPopup]);

  const handleNavClick = (e, path) => {
    if (location.pathname === path) {
      window.location.reload();
      window.scrollTo(0, 0);
    }
  };

  return (
    <div style={{ backgroundColor: "#000", marginTop: "95px" }}>
      <Container maxWidth="xl">
        <div style={{ padding: "0 28px" }}>
          <Box className={styles.footerWrapper}>
            <Grid container className={styles.mainGrid}>
              {/* Left Block with Login */}
              <Grid item xs={12} md={6} lg={4} className={styles.leftBlock}>
                <img src={footerQr} alt="qr" className={styles.qrImg} />
                <Typography className={styles.scanText}>
                  Scan the QR code using your mobile to get the app.
                </Typography>
                <Typography className={styles.title}>
                  Get started with Desi Hisab
                </Typography>

                <Box className={styles.inputGroup}>
                  <div style={{ display: "flex" }}>
                    <Box className={styles.prefix}>+91</Box>
                    <input
                      type="text"
                      placeholder="Enter your phone number"
                      className={styles.inputField}
                      value={phone}
                      onChange={handlePhoneChange}
                      onBlur={handlePhoneBlur}
                      maxLength={10}
                    />
                  </div>
                  <button
                    className={styles.getStartedBtn}
                    onClick={loginFun}
                  >
                    {loader ? (
                      <Box className={styles.loaderLogin}>
                        <Stack sx={{ color: "grey" }} direction="row">
                          <CircularProgress color="inherit" size={20} />
                        </Stack>
                      </Box>
                    ) : (
                      "Get Started"
                    )}
                  </button>
                </Box>

                {phoneError && (
                  <Box className={styles.invalidPhoneNumberMessagemobile}>
                    Please enter a valid phone number
                  </Box>
                )}
                <Box
                  style={{ color: errorColor === "200" ? "green" : "red" }}
                  className={styles.loginSuccessMessagemobile}
                >
                  {loginSuccess}
                </Box>
                <Box className={styles.networkErrorMessagemobile}>
                  {networkError}
                </Box>
              </Grid>

              {/* Center Block */}
              <Grid item xs={12} md={6} lg={5} className={styles.centerBlock}>
                <Grid container spacing={2}>
                  <Grid item xs={4} sm={4} md={4} className={styles.mobileView}>
                    <div className={styles.spaceBox}>
                      <Typography className={styles.columnTitle}>
                        Quick Links
                      </Typography>
                      <ul className={styles.linkList}>
                        <li>
                          <NavLink
                            to="/about"
                            onClick={(e) => handleNavClick(e, "/about")}
                            className={styles.footerlinkcolor}
                          >
                            About
                          </NavLink>
                        </li>
                        <li>
                          <NavLink
                            to="/features"
                            onClick={(e) => handleNavClick(e, "/features")}
                            className={styles.footerlinkcolor}
                          >
                            Features
                          </NavLink>
                        </li>
                        <li>
                          <NavLink
                            to="/faqs"
                            onClick={(e) => handleNavClick(e, "/faqs")}
                            className={styles.footerlinkcolor}
                          >
                            FAQs
                          </NavLink>
                          {/* <a href="">FAQs</a> */}
                        </li>
                      </ul>
                    </div>
                  </Grid>
                  <Grid item xs={4} sm={4} md={4} className={styles.mobileView}>
                    <div className={styles.spaceBox}>
                      <Typography className={styles.columnTitle}>
                        Support
                      </Typography>
                      <ul className={styles.linkList}>
                        <li>
                          <NavLink
                            to="/contactus"
                            onClick={(e) => handleNavClick(e, "/contactus")}
                            className={styles.footerlinkcolor}
                          >
                            Contact
                          </NavLink>
                        </li>
                        <li>
                          <NavLink
                            to="/legal"
                            onClick={(e) => handleNavClick(e, "/legal")}
                            className={styles.footerlinkcolor}
                          >
                            Terms & Condition
                          </NavLink>
                        </li>
                      </ul>
                    </div>
                  </Grid>
                  <Grid item xs={4} sm={4} md={4} className={styles.mobileView}>
                    <div className={styles.spaceBox}>
                      <Typography className={styles.columnTitle}>
                        Social Media
                      </Typography>
                      <ul className={styles.linkList}>
                        <li>
                          <a
                            href="https://www.facebook.com/desihisaab"
                            target="_blank"
                            rel="noreferrer"
                          >
                            <FacebookIcon fontSize="small" /> Facebook
                          </a>
                        </li>
                        <li>
                          <a
                            href="https://x.com/desihisaab"
                            target="_blank"
                            rel="noreferrer"
                          >
                            <XIcon fontSize="small" /> Twitter
                          </a>
                        </li>
                        <li>
                          <a
                            href="https://www.instagram.com/desihisaab/"
                            target="_blank"
                            rel="noreferrer"
                          >
                            <InstagramIcon fontSize="small" /> Instagram
                          </a>
                        </li>
                        <li>
                          <a
                            href="https://www.youtube.com/@DesiHisaab"
                            target="_blank"
                            rel="noreferrer"
                          >
                            <YouTubeIcon fontSize="small" /> Youtube
                          </a>
                        </li>
                      </ul>
                    </div>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={12}
                    md={12}
                    className={styles.mobileView}
                  >
                    <Box className={styles.storeButtons}>
                      <Button
                        className={styles.footerbtn}
                        onClick={() => {
                          window.open(
                            "https://play.google.com/store/apps/details?id=com.desihisab",
                            "_blank"
                          );
                        }}
                      >
                        <img src={playBtn} alt="google" />
                      </Button>
                      <Button
                        className={styles.footerbtn}
                        onClick={() => {
                          window.open(
                            "https://apps.apple.com/in/app/desi-hisab/id6471561568",
                            "_blank"
                          );
                        }}
                      >
                        <img src={storeBtn} alt="app" />
                      </Button>
                      <Button
                        className={styles.footerbtn}
                        onClick={() => {
                          window.open("https://web.desihisab.com", "_blank");
                        }}
                      >
                        <img src={webBtn} alt="web" />
                      </Button>
                    </Box>
                  </Grid>
                </Grid>
              </Grid>

              {/* Right Block */}
              <Grid item xs={12} md={3} className={styles.rightBlock}>
                <img src={footerImg} alt="mobile" className={styles.mobileImg} />
              </Grid>
            </Grid>

            {/* Bottom Copyright */}
            <Box className={styles.poweredByandcopyRight}>
              <Typography className={styles.poweredBy}>
                © 2025 Desi Hisaab. All rights reserved &nbsp;&nbsp;| &nbsp;
                &nbsp; Powered By: <a href="https://www.securemetasys.com/" target="_blank"> SecureMetaSys Infotech Pvt. Ltd.</a>
              </Typography>
            </Box>
          </Box>
        </div>
      </Container>

      {/* Captcha Modal */} 
      <Modal
        open={openPopup}
        closeAfterTransition
        className={styles.loginCaptchaModal}
      >
        <Box className={styles.captchaBox}>
          <Box className={styles.loadCanvas}>
            <LoadCanvasTemplateNoReload />
            <ReplayIcon
              className={styles.reloadCaptcha}
              onClick={handleReloadCaptcha}
            />
          </Box>

          {captchaError && (
            <span className={styles.captchaErrorMessage}>
              Captcha Does Not Match
            </span>
          )}

          <Box className={styles.captchaTextfieldmain}>
            <TextField
              className={styles.captchaTchatextfiel}
              size="medium"
              placeholder="Enter Captcha"
              id="user_captcha_input"
              name="user_captcha_input"
            />
            <Button className={styles.startedbutton} onClick={captchaSubmit}>
              Get Started
            </Button>
          </Box>
        </Box>
      </Modal>
    </div>
  );
};

export default FooterModule;
